import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {
  brandName = environment.brand.name;
  brandLogo = environment.brand.theme.loginBackground;
  constructor() { }

  ngOnInit() {
  }

}
